// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';
import {
  brandSpecificTopRatedBGColor,
  brandSpecificBestSellerBGColor,
  brandSpecificTopRatedColor,
} from '@tcp/core/src/utils/utils.web';

const badgeStyle = css`
  display: inline-flex;
  height: 16px;
  padding: 1px 4px;
  margin-right: 8px;
  white-space: nowrap;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: Nunito;
  font-size: 10px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  align-items: center;
  text-transform: uppercase;
`;
const badgeMobileStyles = css`
  font-size: 8px;
  height: 12px;
  padding: 2px 4px;
  margin-right: 2px;
  border-radius: 4px;
`;
export const TopRatedBadge = Styled.span`
  ${badgeStyle}
  color: ${(props) => brandSpecificTopRatedColor(props)};
  background-color: ${(props) => brandSpecificTopRatedBGColor(props)};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${badgeMobileStyles}
  }
`;
export const BestSellerBadge = Styled.span`
  ${badgeStyle}
  color: ${(props) => props.theme.colors.WHITE};
  background-color: ${(props) => brandSpecificBestSellerBGColor(props)};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${badgeMobileStyles}
  }
`;
export const MostFavoritedBadge = Styled.span`
  ${badgeStyle}
  color: ${(props) => props.theme.colors.WHITE};
  background-color: ${(props) => brandSpecificBestSellerBGColor(props)};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${badgeMobileStyles}
  }
`;
